/*
 * PDP nutrition label — opens the modal.
 *
 * The trigger stays a real link to the file, so a middle click, a right-click
 * "open in new tab" and a page with no JS all still reach the label. This only
 * intercepts the plain left click and shows the dialog instead.
 *
 * One delegated listener, bound once per page: the dialog is looked up on
 * DOCUMENT by id because <modal-dialog> relocates itself to document.body the
 * moment it connects, so it is never beside the link any more.
 */
if (!window.pdpNutritionModalBound) {
  window.pdpNutritionModalBound = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('[data-nutrition-modal]');
    if (!link) return;

    /* A modified click is the visitor asking for the link itself. */
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const modal = document.getElementById(link.dataset.nutritionModal);

    /* No dialog, or it failed to upgrade: leave the click alone so the link
       still opens the label rather than doing nothing. */
    if (!modal || typeof modal.show !== 'function') return;

    event.preventDefault();
    modal.show(link);
  });
}

/*
 * The label picture, when it will not draw.
 *
 * Two ways that happens, both real on this store: the sized copy 404s because
 * Shopify stored the file without ingesting it as an image, and the original is
 * 6000x3375 — past what iOS Safari will decode, where it renders a broken image
 * (Android draws it happily).
 *
 * So: fall back to the original once, and if that fails too, hide the picture
 * and show the note. The download button is untouched either way, and it is
 * what the visitor came for.
 *
 * Capture phase, because `error` does not bubble.
 */
document.addEventListener(
  'error',
  (event) => {
    const img = event.target;
    if (!img || img.tagName !== 'IMG' || !img.classList.contains('nutrition-modal__image')) return;

    const fallback = img.dataset.nutritionFallback;
    if (fallback && img.src !== fallback) {
      delete img.dataset.nutritionFallback;
      img.src = fallback;
      return;
    }

    img.hidden = true;
    const note = img.closest('.nutrition-modal__body')?.querySelector('[data-nutrition-note]');
    if (note) note.hidden = false;
  },
  true
);
